import {
  ICountry,
  ICountryData,
  COUNTRY_NAME_MAX_LENGTH
} from './index'

export class Country implements ICountry {
  readonly id?: number
  name: string
  continent?: string

  constructor(data?: ICountryData) {
    this.id = data?.id
    this.name = data?.name || ''
    this.continent = data?.continent
  }

  validate(): boolean {
    return this.validateName()
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= COUNTRY_NAME_MAX_LENGTH
  }

  update(data?: ICountryData): void {
    this.name = data?.name || this.name
    this.continent = data?.continent || this.continent
  }
}